export var portalParentClassName = 'atlaskit-portal-container';
export var portalParentSelector = 'body > .atlaskit-portal-container';
export var portalClassName = 'atlaskit-portal';